import Navigation from './pages';
import './assets/scss/theme.scss';

function App() {
  return <Navigation />;
}

export default App;
